import http from './base';

// 商品 Products
export const getProducts = (params) => http.fetchGet('/products', params) ;
export const getProductDetail = (params) =>  http.fetchGet(`/products/${params.productId}`);

//Site Contents
export const getChannels = (params) => http.fetchGet('/cms/channels', params);
export const getBanners = (params) => http.fetchGet('/cms/banners', params);
export const getPosts = (params) => http.fetchGet('/posts', params);